// extracted by mini-css-extract-plugin
export default {"modal":"DoubleConfirmation-module__modal__ANtz2","content":"DoubleConfirmation-module__content__MDY4Q","text":"DoubleConfirmation-module__text__T+rbL"};